import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import Avatar1 from '../../Image/avatar1.png';
import Avatar2 from '../../Image/Avatar2.png';
import './css/creneauResto.css';
import { useSelector } from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { withStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import SelectUI from '@material-ui/core/Select';
import { blockInvalidChar } from "../../components/blockInvalidChar";

import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { KeyboardTimePicker } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import { fr } from "date-fns/locale";
import { AfficheResaSite, DemandeConfirmation, ChangeNombrePersonne, ChangeEtatResaDirect, ChangeResaDirect } from '../../Api/RestaurantApi/DetailsCreneau';

const Creneau = () => {
    const [dataSite, setDataSite] = useState([]);
    const [filterSite, setFilterSite] = useState([]);
    const [dataDirect, setDataDirect] = useState([]);
    const [filterDirect, setFilterDirect] = useState([]);
    const [loading, setLoading] = useState(false);

    const [loadConfirmation, setLoadConfirmation] = useState(false);
    const [loadPersonne, setLoadPersonne] = useState(false);
    const [loadEtat, setLoadEtat] = useState(false);
    const [loadChangeResa, setLoadChangeResa] = useState(false);

    const [idResaPersonne, setIdResaPersonne] = useState('');
    const [nombrePersonne, setNombrePersonne] = useState('');

    const [idResaEtat, setIdResaEtat] = useState('');
    const [etat, setEtat] = useState('');


    const [idResa, setIdResa] = useState('');

    const [anne, setAnne] = useState([]);
    const [mois, setMois] = useState([]);
    const [date, setDate] = useState([]);
    const [creneau, setCreneau] = useState([]);

    const [showPersonne, setShowPersonne] = useState(false);
    const [showEtat, setShowEtat] = useState(false);
    const [showUpdateResa, setShowUpdateResa] = useState(false);


    const [dateUpdate, setDateUpdate] = useState(new Date());

    const createDateFromTextValue = (value) => {
        const splitParts = value.split(":");
        return new Date(2022, 1, 1, splitParts[0], splitParts[1]);
    };
    const [creneauUpdate, setCreneauUpdate] = useState(createDateFromTextValue("00:00"));
    const [nom, setNom] = useState('');
    const [prenom, setPrenom] = useState('');
    const [telephone, setTelephone] = useState('');
    const [prise, setPrise] = useState('');
    const [email, setEmail] = useState('');
    const [canal, setCanal] = useState('');
    const [nbrPersonne, setNbrPersonne] = useState('');
    const [demande, setDemande] = useState('');
    const [errorCreneau, setErrorCreneau] = useState('');

    const [openDropDown, setOpenDropDown] = useState(false);

    const restaurant = useSelector((state) => state.restaurant);

    let location = useLocation();


    useEffect(() => {
        AfficheResaRestoSite();

    }, []);

    const BootstrapInput = withStyles((theme) => ({
        root: {
            'label + &': {
                marginTop: theme.spacing(3),
            },
        },
        input: {
            borderRadius: 0,
            position: 'relative',
            backgroundColor: 'white',
            border: '1px solid #70c4e7',
            fontSize: 16,
            width: 300,
            color: '#4ba7cc',
            padding: '12px 0px 5px 12px!important',
            transition: theme.transitions.create(['border-color', 'box-shadow']),
            '&:focus': {
                borderRadius: 0,
                borderColor: '#70c4e7',
                boxShadow: 'none',
                backgroundColor: 'white',
                color: '#4ba7cc',
            },
        },
    }))(InputBase);


    const singleValue = (value) => {
        if (value < 10) {
            return "0" + value;
        } else {
            return value;
        }
    }

    const AfficheResaRestoSite = () => {
        setLoading(true);
        AfficheResaSite(restaurant.id)
            .then(function (response) {
                console.log("data Site =>", response.data.donner);
                setDataSite(response.data.donner.reservation);
                setFilterSite(response.data.donner.reservation);

                setDataDirect(response.data.donner.reservationDirect);
                setFilterDirect(response.data.donner.reservationDirect);


                const dataAnne = [];
                const dataMois = [];
                const dataJour = [];
                const dataCreneau = [];

                response.data.donner.reservation.forEach((element) => {
                    const existeAnne = dataAnne.find((item) => item.value === element.anne);

                    console.log("Existe Anne", existeAnne);
                    if (existeAnne) {
                        console.log("Anne existe");
                    } else {
                        dataAnne.push({ value: element.anne, label: element.anne });
                    }

                    const existeMois = dataMois.find((item) => item.value === element.mois);
                    console.log("Existe mois", existeMois);

                    if (existeMois) {
                        console.log("Mois existe");
                    } else {
                        dataMois.push({ value: element.mois, label: element.mois });
                    }

                    const existeJour = dataJour.find((item) => item.value === element.jour);
                    console.log("Existe Jour", existeJour);

                    if (existeJour) {
                        console.log("Jour existe");
                    } else {
                        dataJour.push({ value: element.jour, label: element.jour });
                    }

                    const heure = singleValue(new Date(element.heurePrise).getUTCHours()) + ":" + singleValue(new Date(element.heurePrise).getMinutes());

                    const existeCreneau = dataCreneau.find((item) => item.value === heure);

                    console.log("Existe Creneau", existeCreneau);

                    if (existeCreneau) {
                        console.log("creneau existe");
                    } else {
                        dataCreneau.push({ value: heure, label: heure });
                    }

                });


                response.data.donner.reservationDirect.forEach((element) => {
                    const existeAnne = dataAnne.find((item) => item.value === element.anne);

                    console.log("Existe Anne Direct", existeAnne);
                    if (existeAnne) {
                        console.log("Anne Direct");
                    } else {
                        dataAnne.push({ value: element.anne, label: element.anne });
                    }

                    const existeMois = dataMois.find((item) => item.value === element.mois);
                    console.log("Existe mois Direct", existeMois);

                    if (existeMois) {
                        console.log("Mois existe Direct");
                    } else {
                        dataMois.push({ value: element.mois, label: element.mois });
                    }

                    const existeJour = dataJour.find((item) => item.value === element.date);
                    console.log("Existe jour Direct", existeJour);

                    if (existeJour) {
                        console.log("Jour existe Direct");
                    } else {
                        dataJour.push({ value: element.date, label: element.date });
                    }


                    const existeCreneau = dataCreneau.find((item) => item.value === element.creneau);

                    console.log("Existe Creneau Direct", existeCreneau);

                    if (existeCreneau) {
                        console.log("creneau existe Direct");
                    } else {
                        dataCreneau.push({ value: element.creneau, label: element.creneau });
                    }

                });

                setAnne([...dataAnne].sort((a, b) => a.value > b.value ? 1 : -1));
                setMois([...dataMois].sort((a, b) => a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1));
                setDate([...dataJour].sort((a, b) => a.value > b.value ? 1 : -1));
                setCreneau([...dataCreneau].sort((a, b) => a.value > b.value ? 1 : -1));


            })
            .catch(function (error) {
                console.log(error);
            })
            .finally(function () {
                setLoading(false);
            });
    };



    const couvertSite = dataSite.reduce((prev, current) => prev + parseInt(current.nombrePersonne), 0);
    const couvertDirect = dataDirect.reduce((prev, current) => prev + parseInt(current.nombrePersonne), 0);



    const viewPseudo = (item) => {
        const nom = item.client.nom.charAt(0).toUpperCase();
        const prenom = item.client.prenom.charAt(0).toUpperCase();

        if (item.client.affichagePseudo === "1") {
            return (<div className='d-flex justify-content-center'>
                <span className='pseudo'>{item.client.nom} {item.client.prenom}</span>
            </div>)
        } else if (item.client.affichagePseudo === "2") {
            return (<div className='d-flex justify-content-center'>
                <span className='pseudo'>{item.client.prenom} {nom}</span>
            </div>)
        } else if (item.client.affichagePseudo === "3") {
            return (<div className='d-flex justify-content-center'>
                <span className='pseudo'>{prenom} {item.client.prenom}</span>
            </div>)
        } else {
            return (<div className='d-flex justify-content-center'>
                <span className='pseudo'>{nom} {prenom}</span>
            </div>)
        }


    }


    const viewDateHeure = (item) => {

        const datePrise = new Date(item.datePrise).getFullYear() + "/" + singleValue(parseInt(new Date(item.datePrise).getUTCMonth() + 1)) + "/" + singleValue(new Date(item.datePrise).getDate());
        const heurePrise = singleValue(new Date(item.heurePrise).getUTCHours()) + ":" + singleValue(new Date(item.heurePrise).getMinutes());
        return (<div className='d-flex justify-content-between mt-2'>
            <span>Réservation le {datePrise} à {heurePrise}</span>
            <span><strong>Pour {item.nombrePersonne} personnes</strong></span>
        </div>)
    }

    const viewReservationNumero = (item) => {
        const datePrise = new Date(item.datePrise).getFullYear() + "/" + singleValue(parseInt(new Date(item.datePrise).getUTCMonth() + 1)) + "/" + singleValue(new Date(item.datePrise).getDate());
        return (<span>- N° de réservation, du <strong>[{datePrise}]</strong></span>)
    }



    const viewDateResa = (item) => {
        const datePrise = new Date(item.createdAt).getFullYear() + "/" + singleValue(parseInt(new Date(item.createdAt).getUTCMonth() + 1)) + "/" + singleValue(new Date(item.createdAt).getDate());
        return (<div className='direct'>  <span>Résa prise par Admin le <strong>[{datePrise}]</strong> </span></div>)
    }



    const handleAnne = (value) => {
        const anneDataSite = dataSite.filter((el) => el.anne === value);
        const anneDataDirect = dataDirect.filter((el) => el.anne === value);

        setFilterSite(anneDataSite);
        setFilterDirect(anneDataDirect);
    }

    const HandleMois = (value) => {
        const anneDataSite = dataSite.filter((el) => el.mois === value);
        const anneDataDirect = dataDirect.filter((el) => el.mois === value);

        setFilterSite(anneDataSite);
        setFilterDirect(anneDataDirect);
    }

    const handleJour = (value) => {
        const anneDataSite = dataSite.filter((el) => el.jour === value);
        const anneDataDirect = dataDirect.filter((el) => el.date === value);

        setFilterSite(anneDataSite);
        setFilterDirect(anneDataDirect);
    }

    const handleFormateCreneau = (heure) => {
        return singleValue(new Date(heure).getUTCHours()) + ":" + singleValue(new Date(heure).getMinutes());
    }

    const handleCreneau = (value) => {

        const anneDataSite = dataSite.filter((el) => handleFormateCreneau(el.heurePrise) === value);
        const anneDataDirect = dataDirect.filter((el) => el.creneau === value);

        setFilterSite(anneDataSite);
        setFilterDirect(anneDataDirect);
    }

    const handleConfirmation = (item) => {
        const heure = singleValue(new Date(item.heurePrise).getUTCHours()) + ":" + singleValue(new Date(item.heurePrise).getMinutes());
        const datePrise = new Date(item.datePrise).getFullYear() + "/" + singleValue(parseInt(new Date(item.datePrise).getUTCMonth() + 1)) + "/" + singleValue(new Date(item.datePrise).getDate());
        setLoadConfirmation(true);
        const data = { email: item.client.email, nomRestaurant: item.restaurant.nomRestaurant, date: datePrise, heure: heure };
        DemandeConfirmation(data).then(function (response) {
            if (response.data.title === "success") {
                toast.success(response.data.message);
            }
        }).catch(function (error) {
            console.log(error.response);
            toast.warning(error.response.data.message);
        }).finally(function () {
            setLoadConfirmation(false);
        });
    }

    const handleClosePersonne = () => setShowPersonne(false);
    const handleCloseEtat = () => setShowEtat(false);
    const handleCloseUpdateResa = () => setShowUpdateResa(false);


    const handleEditPersonne = (id) => {
        setIdResaPersonne(id);
        setShowPersonne(true);
    }


    const handleUpdatePersonne = (e) => {
        e.preventDefault();
        setLoadPersonne(true);
        const data = { personne: nombrePersonne, idReservation: idResaPersonne };
        ChangeNombrePersonne(data).then(function (response) {
            if (response.data.title === "success") {
                toast.success(response.data.message);
                AfficheResaRestoSite();
            }
        }).catch(function (error) {
            console.log(error.response);
            toast.warning(error.response.data.message);
        }).finally(function () {
            setLoadPersonne(false);
            setShowPersonne(false);
        });
    }

    const handleUpdateEtat = (e) => {
        e.preventDefault();
        setLoadEtat(true);
        const data = { etat: etat, idReservation: idResaEtat };
        ChangeEtatResaDirect(data).then(function (response) {
            if (response.data.title === "success") {
                toast.success(response.data.message);
                AfficheResaRestoSite();
            }
        }).catch(function (error) {
            console.log(error.response);
            toast.warning(error.response.data.message);
        }).finally(function () {
            setLoadEtat(false);
            setShowEtat(false);
            setEtat('');
        });

    }

    const handleEditEtat = (id) => {
        setIdResaEtat(id);
        setShowEtat(true);
    }

    const handleChange = (e) => {
        setEtat(e.target.value);
    }





    const dateFormat = (date) => {
        if (date < 10) {
            return '0' + date;
        } else {
            return date;
        }
    }

    const formateMonth = (mois) => {
        return "JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(mois) / 3 + 1;
    }


    const handleEditResa = (item) => {
        setIdResa(item.id);
        setNom(item.nom);
        setPrenom(item.prenom);
        setTelephone(item.telephone);
        setEmail(item.email);
        setCanal(item.canal);
        setDemande(item.demandeSpecifique);
        setPrise(item.reserverPar);
        setNbrPersonne(item.nombrePersonne);
        setShowUpdateResa(true);
        setCreneauUpdate(createDateFromTextValue(item.creneau));
        setDateUpdate(new Date(item.anne + "-" + formateMonth(item.mois) + "-" + item.date))
    }

    const handleUpdateReservation = (e) => {
        e.preventDefault();
        if (creneauUpdate.getHours() === 0) {
            setErrorCreneau('Donner obligatoire');
            const timer = setTimeout(() => setErrorCreneau(''), 3000);
            return () => clearTimeout(timer);
        } else {
            setLoadChangeResa(true);
            var opt_month = { month: 'short' };

            const data = {
                idReservation: idResa, anne: dateUpdate.getFullYear(), mois: dateUpdate.toLocaleDateString('en-US', opt_month), jour: dateFormat(dateUpdate.getDate()),
                nom: nom, prenom: prenom, telephone: telephone, email: email, nombrePersonne: nbrPersonne, demandeSpecifique: demande, creneau: dateFormat(creneauUpdate.getHours()) + ":" + dateFormat(creneauUpdate
                    .getMinutes()), prise: prise, canal: canal
            };
            ChangeResaDirect(data).then(function (response) {
                if (response.data.title === "success") {
                    toast.success(response.data?.message);
                    AfficheResaRestoSite();
                }
            }).catch(function (error) {
                console.log(error.response);
                toast.warning(error.response.data?.message);
            }).finally(function () {
                setDateUpdate(new Date());
                setCreneauUpdate(createDateFromTextValue("00:00"));
                setNom('');
                setPrenom('');
                setTelephone('');
                setEmail('');
                setNbrPersonne('');
                setDemande('');
                setPrise('');
                setCanal('');
                setLoadChangeResa(false);
                setShowUpdateResa(false);
            });
        }

    }


    const handleDrop = () => {
        setOpenDropDown(!openDropDown);
    }


    const handleReset = () => {
        AfficheResaRestoSite();
    }


    const handlePromo = (value) => {
        const dataFilter = dataSite.filter((el) => el.promo === value);
        setFilterSite(dataFilter);
    }

    const handleCLient = (value) => {
        const dataFilter = dataSite.filter((el) => el.dejasVenus === value);
        setFilterSite(dataFilter);
    }

    const handlePersonne = (value) => {
        if (value === "11") {
            const dataSiteFilter = dataSite.filter((el) => el.nombrePersonne >= value);
            const dataDirectFilter = dataDirect.filter((el) => el.nombrePersonne >= value);
            setFilterSite(dataSiteFilter);
            setFilterDirect(dataDirectFilter);
        } else {
            const dataSiteFilter = dataSite.filter((el) => el.nombrePersonne === value);
            const dataDirectFilter = dataDirect.filter((el) => el.nombrePersonne === value);
            setFilterSite(dataSiteFilter);
            setFilterDirect(dataDirectFilter);
        }
    }

    return (
        <div>
            <Helmet>
                <title>Créneau</title>
                <meta name='description' content='Restaurant créneau .' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <div className='creneau'>
                <div className='container'>
                    <div className='bloc_creneau'>
                        <div className='creneau_titre'>
                            <div className='d-flex mt-2 titre'>
                                <i className='fa fa-clock-o'></i> <h1>Etats de réservations – vision détail créneau</h1>
                            </div>
                            <div className='creneau_renseignement'>
                                <p>Affichage des réservations sur un créneau particulier. <span className='avertissement'>Attention : </span> le bouton « Demande de confirmation » ne doit être utilisé que de façon très exceptionnelle, et ce au plus tard 12h avant la prestation, au risque de perdre vos clients!
                                </p>
                            </div>
                        </div>
                        <div className='creneau_content'>
                            <div className='creneau_select'>
                                <div className='anner'>
                                    <Select
                                        placeholder="Année"
                                        onChange={(e) => handleAnne(e.value)}
                                        options={anne} />
                                </div>
                                <div className='mois'>
                                    <Select
                                        placeholder="Mois ..."
                                        onChange={(e) => HandleMois(e.value)}
                                        options={mois} />
                                </div>
                                <div className='date'>
                                    <Select
                                        placeholder="Date ..."
                                        onChange={(e) => handleJour(e.value)}
                                        options={date} />
                                </div>
                                <div className='crene'>
                                    <Select
                                        placeholder="Créneau ..."
                                        onChange={(e) => handleCreneau(e.value)}
                                        options={creneau} />
                                </div>
                                <div className='filter'>
                                    <button className="btn" onClick={handleDrop}>Filtre</button>
                                </div>
                            </div>
                            <div className='titre_creneau'>
                                <h2>Nombre de résérvation : {dataSite.length + dataDirect.length} – Nombre de couverte : {couvertSite + couvertDirect}</h2>
                            </div>

                            <div className='col-xs-12 col-12 col-sm-12'>
                                <div className='d-flex justify-content-end'>
                                    <div className={openDropDown === true ? "body-filter show" : "body-filter"}>
                                        <div className="filter-content">
                                            <div className='filter_item'>
                                                <div className="filter_titre">
                                                    <span className='filter_client'>Client</span>
                                                </div>
                                                <div className="filter_liste">
                                                    <div>
                                                        <div className="form-check form-check-inline">
                                                            <input className="form-check-input" type="radio" name="inlineRadioclient" onChange={() => handleCLient("Non")} id="inlineRadio1" defaultValue="option1" />
                                                            <label className="form-check-label" htmlFor="inlineRadio1" >Nouveau</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input className="form-check-input" type="radio" onChange={() => handleCLient("Oui")} name="inlineRadioclient" id="inlineRadio2" defaultValue="option2" />
                                                            <label className="form-check-label" htmlFor="inlineRadio2">Déjas venue</label>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className='filter_item'>
                                                <div className="filter_titre">
                                                    <span className='filter_promo'>Promotion</span>
                                                </div>
                                                <div className="filter_liste pb-1">
                                                    <span onClick={() => handlePromo("Promotion de -50%")}>-50%</span>
                                                    <span onClick={() => handlePromo("Promotion de -40%")}>-40%</span>
                                                    <span onClick={() => handlePromo("Promotion de -30%")}>-30%</span>
                                                    <span onClick={() => handlePromo("Promotion de -20%")}>-20%</span>
                                                    <span onClick={() => handlePromo("Promotion de -10%")}>-10%</span>
                                                </div>
                                            </div>
                                            <div className='filter_item'>
                                                <div className="filter_titre">
                                                    <span className='filter_personne'>Personne</span>
                                                </div>
                                                <div className="filter_liste ">
                                                    <div>
                                                        <div className="form-check form-check-inline">
                                                            <input className="form-check-input" type="radio" onChange={() => handlePersonne("1")} name="inlineRadioOptions" id="inlinePersonne1" defaultValue="personne1" />
                                                            <label className="form-check-label" htmlFor="inlineRadio1" >1</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input className="form-check-input" type="radio" onChange={() => handlePersonne("2")} name="inlineRadioOptions" id="inlinePersonne2" defaultValue="option2" />
                                                            <label className="form-check-label" htmlFor="inlinePersonne2">2</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input className="form-check-input" type="radio" onChange={() => handlePersonne("3")} name="inlineRadioOptions" id="inlinePersonne3" defaultValue="option3" />
                                                            <label className="form-check-label" htmlFor="inlinePersonne3">3</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input className="form-check-input" type="radio" onChange={() => handlePersonne("4")} name="inlineRadioOptions" id="inlinePersonne4" defaultValue="option4" />
                                                            <label className="form-check-label" htmlFor="inlinePersonne4">4</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input className="form-check-input" type="radio" onChange={() => handlePersonne("5")} name="inlineRadioOptions" id="inlinePersonne5" defaultValue="option5" />
                                                            <label className="form-check-label" htmlFor="inlinePersonne5">5</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input className="form-check-input" type="radio" onChange={() => handlePersonne("6")} name="inlineRadioOptions" id="inlinePersonne6" defaultValue="option6" />
                                                            <label className="form-check-label" htmlFor="inlinePersonne6">6</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input className="form-check-input" type="radio" onChange={() => handlePersonne("7")} name="inlineRadioOptions" id="inlinePersonne7" defaultValue="option7" />
                                                            <label className="form-check-label" htmlFor="inlinePersonne7">7</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input className="form-check-input" type="radio" onChange={() => handlePersonne("8")} name="inlineRadioOptions" id="inlinePersonne8" defaultValue="option8" />
                                                            <label className="form-check-label" htmlFor="inlinePersonne8">8</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input className="form-check-input" type="radio" onChange={() => handlePersonne("9")} name="inlineRadioOptions" id="inlinePersonne9" defaultValue="option9" />
                                                            <label className="form-check-label" htmlFor="inlinePersonne9">9</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input className="form-check-input" type="radio" onChange={() => handlePersonne("10")} name="inlineRadioOptions" id="inlinePersonne10" defaultValue="option10" />
                                                            <label className="form-check-label" htmlFor="inlinePersonne10">10</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input className="form-check-input" type="radio" onChange={() => handlePersonne("11")} name="inlineRadioOptions" id="inlinePersonne11" defaultValue="option11" />
                                                            <label className="form-check-label" htmlFor="inlinePersonne11">+10</label>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="footer-value">
                                            <div className="action">
                                                <button className="btn btn_reinitialiser btn-sm" onClick={handleReset}>
                                                    Reinitialiser
                                                </button>
                                                <button className="btn btn_fermerFilter btn-sm" onClick={() => setOpenDropDown(false)}>
                                                    Fermer
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className='reservation_creneau' onClick={() => setOpenDropDown(false)}>


                                {loading === true ?
                                    <div className="d-flex justify-content-center">
                                        <Spinner
                                            animation="border"
                                            className="load"
                                            variant="info"
                                            size="md"
                                        />
                                    </div> :
                                    <div className='row'>
                                        <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                            <div>
                                                <div className='type'>
                                                    <h3 className='text-center'>Réservations via le site</h3>
                                                    <i className="fa fa-cutlery"></i>
                                                </div>
                                                {filterSite.length !== 0 ? filterSite.map((item, index) => {
                                                    return (
                                                        <div className='liste_resa mt-3' key={index}>
                                                            <div className='bloc'>
                                                                <div className='d-flex justify-content-center'>
                                                                    {item.client.sexe === "Homme" ?
                                                                        <div className='image_avatar'>
                                                                            <img src={Avatar2} width="80px" alt="avatar client" />
                                                                        </div> :
                                                                        <div className='image_avatar'>
                                                                            <img src={Avatar1} width="80px" alt="avatar client" />
                                                                        </div>}

                                                                </div>
                                                                {viewPseudo(item)}
                                                                <span className='deja'>{item.dejasVenus === "Oui" ? "Déjà venue" : "Nouveau"}</span>
                                                                {viewDateHeure(item)}

                                                                <div className='mt-2'>
                                                                    <span className='promo'><i className='fa fa-bookmark'></i>{item.promo !== null ? item.promo : "Sans promo"} !</span>
                                                                </div>
                                                                {/* <div className='value_promo'>
                                                                <span>- Hors boisson</span><br />
                                                                <span>- Pour toute commande d’Entrée+Plat ou Plat+Dessert minimum par personne.</span>
                                                            </div> */}
                                                                <div className='mt-2'>
                                                                    <span className='validiter'><i className='fa fa-check'></i>Validité</span>
                                                                </div>
                                                                <div className='validiter_value'>
                                                                    <span>- Valable pour le créneau horaire réservé.</span><br />
                                                                    <span>- Demande spécifique : {item.demandeSpecifique !== null ? item.demandeSpecifique : ""} </span><br />

                                                                    {viewReservationNumero(item)}<br />
                                                                    <span>- Canal: <strong>[via le site]</strong></span><br />
                                                                    <span>- Etat de la réservation <strong className='terminer'>[{item.etat}]</strong>.</span>
                                                                </div>
                                                                <div className='action d-flex justify-content-between mt-3'>
                                                                    {loadConfirmation ? <Button className='btn btn_DemandeConfirme' disabled>
                                                                        <Spinner
                                                                            as="span"
                                                                            animation="border"
                                                                            size="sm"
                                                                            role="status"
                                                                            aria-hidden="true"
                                                                            variant="info"
                                                                            className="spiner"
                                                                        />
                                                                        Chargement...
                                                                    </Button> : <button className='btn' onClick={() => handleConfirmation(item)}>Demande de confirmation</button>}

                                                                    <button className='btn' onClick={() => handleEditPersonne(item.id)}>Nombre personne</button>
                                                                    <button className='btn' onClick={() => handleEditEtat(item.id)}>Changer etat</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                }) : <p>Vide ...</p>}

                                            </div>
                                        </div>
                                        <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 direct'>
                                            <div>
                                                <div className='type'>
                                                    <h3 className='text-center'>Réservations en direct</h3>
                                                    <i className="fa fa-cutlery"></i>
                                                </div>
                                                {filterDirect.length !== 0 ? filterDirect.map((item, index) => {
                                                    return (
                                                        <div className='bloc mt-3' key={index}>
                                                            <div className='d-flex justify-content-center'>
                                                                <span className='pseudo'>{item.nom} {item.prenom}</span>
                                                            </div>
                                                            <div className='direct'> <span className='mt-2'>Numéro téléphone: <strong>[{item.telephone}]</strong></span></div>
                                                            <div className='direct'> <span>Mail: <strong>[{item.email}]</strong></span></div>
                                                            <div className='direct'> <span>Réservation pour le <strong>[{item.anne}/{formateMonth(item.mois)}/{item.date} à {item.creneau}]</strong> </span></div>
                                                            <div className='direct'> <span>Réservation pour <strong>[{item.nombrePersonne} personnes]</strong></span></div>
                                                            <div className='direct'> <span>Demande spécifique: {item.demandeSpecifique} </span><br /></div>
                                                            {viewDateResa(item)}
                                                            <div className='direct'><span>Canal : en direct : par <strong>[{item.canal}]</strong></span></div>
                                                            <div className='direct'><span>Etat de la réservation: <strong className='valider'>[validé]</strong>.</span></div>
                                                            <div className='action d-flex justify-content-center mt-3'>
                                                                <button className='btn' onClick={() => handleEditResa(item)}>Modifier</button>
                                                            </div>
                                                        </div>
                                                    )
                                                }) : <p>Vide ...</p>}
                                            </div>
                                            
                                        </div>
                                        <p className='version'>Version 1</p>
                                        <Modal show={showPersonne} onHide={handleClosePersonne}>
                                            <Modal.Body>
                                                <div className='modal_modifier_personne'>
                                                    <div className='modal_modifer_header'>
                                                        <span>Modifier nombre personne</span>
                                                    </div>
                                                    <form onSubmit={handleUpdatePersonne}>
                                                        <div className="mb-3 form_body">
                                                            <div className='d-flex justify-content-center'>
                                                                <input type="text" className="form-control" required value={nombrePersonne} onChange={(e) => setNombrePersonne(e.target.value)} id="exampleFormControlInput1" placeholder="Nombre personne ..." />
                                                            </div>
                                                            <div className='d-flex justify-content-between'>
                                                                <button type='button' className='btn btn-dark' onClick={handleClosePersonne}>Fermer</button>
                                                                {loadPersonne ? <Button className='btn btn_DemandePersonne' disabled>
                                                                    <Spinner
                                                                        as="span"
                                                                        animation="border"
                                                                        size="sm"
                                                                        role="status"
                                                                        aria-hidden="true"
                                                                        variant="info"
                                                                        className="spiner"
                                                                    />
                                                                    Chargement...
                                                                </Button> : <button type='submit' className='btn btn_modifier'>Modifier</button>}

                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </Modal.Body>
                                        </Modal>

                                        <Modal show={showEtat} onHide={handleCloseEtat}>
                                            <Modal.Body>
                                                <div className='modal_modifier_personne'>
                                                    <div className='modal_modifer_header'>
                                                        <span>Modifier l'etat de reservation</span>
                                                    </div>
                                                    <form onSubmit={handleUpdateEtat}>
                                                        <div className="mb-3 form_body">
                                                            <div className='d-flex justify-content-center'>
                                                                <FormControl>
                                                                    <SelectUI
                                                                        id="demo-customized-select"
                                                                        onChange={(e) => handleChange(e)}
                                                                        value={etat}
                                                                        displayEmpty
                                                                        required
                                                                        placeholder="Changer l'etat"
                                                                        renderValue={(etat) => etat !== "" ? etat : <em>Changement Etat</em>}
                                                                        input={<BootstrapInput />}
                                                                    >
                                                                        <MenuItem value="Réservé">Réservé</MenuItem>
                                                                        <MenuItem value="Confirmé">Confirmé</MenuItem>
                                                                        <MenuItem value="Annulé">Annulé</MenuItem>
                                                                        <MenuItem value="No show">No show</MenuItem>
                                                                        <MenuItem value="Arrivé">Client est arrivé</MenuItem>
                                                                        <MenuItem value="Addition">Addition</MenuItem>
                                                                    </SelectUI>
                                                                </FormControl>
                                                            </div>

                                                            <div className='d-flex justify-content-between'>
                                                                <button type='button' className='btn btn-dark' onClick={handleCloseEtat}>Fermer</button>
                                                                {loadEtat ? <Button className='btn btn_DemandePersonne' disabled>
                                                                    <Spinner
                                                                        as="span"
                                                                        animation="border"
                                                                        size="sm"
                                                                        role="status"
                                                                        aria-hidden="true"
                                                                        variant="info"
                                                                        className="spiner"
                                                                    />
                                                                    Chargement...
                                                                </Button> : <button type='submit' className='btn btn_modifier'>Modifier</button>}

                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </Modal.Body>
                                        </Modal>


                                        <Modal show={showUpdateResa} size="lg" onHide={handleCloseUpdateResa}>
                                            <Modal.Body>
                                                <div className='modal_modifier_personne'>
                                                    <div className='modal_modifer_header'>
                                                        <span>Modifier réservation</span>
                                                    </div>
                                                    <form onSubmit={handleUpdateReservation}>
                                                        <div className="mb-3 form_body">
                                                            <div className='row'>

                                                                <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-flex justify-content-center">
                                                                    <div>
                                                                        <div className="element ">
                                                                            <label htmlFor="date" className="col-form-label">Nom: </label>
                                                                            <div className="input">
                                                                                <input type="text" value={nom} onChange={(e) => setNom(e.target.value)} required className="form-control" placeholder="Nom ..." />
                                                                            </div>
                                                                        </div>
                                                                        <div className="element">
                                                                            <label htmlFor="date" className="col-form-label">Prénom: </label>
                                                                            <div className="input">
                                                                                <input type="text" value={prenom} onChange={(e) => setPrenom(e.target.value)} required className="form-control" placeholder="Prénom ..." />
                                                                            </div>
                                                                        </div>
                                                                        <div className="element">
                                                                            <label htmlFor="date" className="col-form-label">Numéro téléphone: </label>
                                                                            <div className="input ">
                                                                                <input type="text" value={telephone} onChange={(e) => setTelephone(e.target.value)} required className="form-control" placeholder="Numéro téléphone ..." />
                                                                            </div>
                                                                        </div>
                                                                        <div className="element">
                                                                            <label htmlFor="date" className="col-form-label">Réservation prise par: </label>
                                                                            <div className="input ">
                                                                                <input type="text" value={prise} onChange={(e) => setPrise(e.target.value)} required className="form-control" placeholder="Prise par ..." />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-flex justify-content-center">
                                                                    <div>
                                                                        <div className="element">
                                                                            <label htmlFor="date" className="col-form-label">Adresse email: </label>
                                                                            <div className="input ">
                                                                                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="form-control" placeholder="Adresse email ..." />
                                                                            </div>
                                                                        </div>
                                                                        <div className="element">
                                                                            <label htmlFor="date" className="col-form-label">Canal en direct par: </label>
                                                                            <div className="input ">
                                                                                <input type="text" value={canal} onChange={(e) => setCanal(e.target.value)} required className="form-control" placeholder="Ex: téléphone,email,sur place ..." />
                                                                            </div>
                                                                        </div>
                                                                        <div className="element">
                                                                            <label htmlFor="date" className="col-form-label">Date: </label>
                                                                            <div className="input ">
                                                                                <MuiPickersUtilsProvider locale={fr} utils={DateFnsUtils}>
                                                                                    <KeyboardDatePicker
                                                                                        value={dateUpdate}
                                                                                        placeholder="10/10/2018"
                                                                                        required
                                                                                        onChange={value => setDateUpdate(value)}
                                                                                        minDate={new Date()}
                                                                                        format="MM/dd/yyyy"
                                                                                    />

                                                                                </MuiPickersUtilsProvider>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-flex justify-content-center">

                                                                    <div>
                                                                        <div className="element ">
                                                                            <label htmlFor="date" className="col-form-label">Créneau: </label>
                                                                            <div className="input ">
                                                                                <MuiPickersUtilsProvider locale={fr} utils={DateFnsUtils}>
                                                                                    <div className="d-flex flex-column">
                                                                                        <KeyboardTimePicker
                                                                                            label="Créneau"
                                                                                            placeholder="00:00"
                                                                                            ampm={false}
                                                                                            name="creneau"
                                                                                            required
                                                                                            minutesStep={5}
                                                                                            value={creneauUpdate}
                                                                                            onChange={date => setCreneauUpdate(createDateFromTextValue(date.getHours() + ":" + date.getMinutes()))}
                                                                                        />
                                                                                    </div>
                                                                                </MuiPickersUtilsProvider>
                                                                                {errorCreneau !== "" ? <span className='errorValue  mt-1'>{errorCreneau}</span> : ""}
                                                                            </div>
                                                                        </div>
                                                                        <div className="element ">
                                                                            <label htmlFor="date" className="col-form-label">Nombre de personnes: </label>
                                                                            <div className="input ">
                                                                                <input type="number" value={nbrPersonne} onChange={(e) => setNbrPersonne(e.target.value)} required onKeyDown={blockInvalidChar} className="form-control number" placeholder="0" />
                                                                            </div>
                                                                        </div>
                                                                        <div className="element">
                                                                            <label htmlFor="date" className="col-form-label">Demande spécifique: </label>
                                                                            <div className="input ">
                                                                                <textarea className="form-control" value={demande} onChange={(e) => setDemande(e.target.value)} id="exampleFormControlTextarea1" placeholder="Demande spécifique ..." rows="1" />
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div className='d-flex justify-content-between'>
                                                                <button type='button' className='btn btn-dark' onClick={handleCloseUpdateResa}>Fermer</button>
                                                                {loadChangeResa ? <Button className='btn btn_DemandePersonne' disabled>
                                                                    <Spinner
                                                                        as="span"
                                                                        animation="border"
                                                                        size="sm"
                                                                        role="status"
                                                                        aria-hidden="true"
                                                                        variant="info"
                                                                        className="spiner"
                                                                    />
                                                                    Chargement...
                                                                </Button> : <button type='submit' className='btn btn_modifier'>Modifier</button>}

                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </Modal.Body>
                                        </Modal>
                                    </div>
                                }



                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Creneau